import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgArrowShow24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Arrow Show"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21 5.75a.75.75 0 0 0-1.5 0v12a.75.75 0 0 0 1.5 0zm-3.11 5.727a.72.72 0 0 1 0 .547.3.3 0 0 1-.039.065 1 1 0 0 0-.047.078.4.4 0 0 1-.052.08l-4.869 5.261a.76.76 0 0 1-1.06.05.73.73 0 0 1-.05-1.041l3.728-4.03H3.75A.744.744 0 0 1 3 11.75c0-.407.336-.737.75-.737H15.5l-3.728-4.03a.73.73 0 0 1 .05-1.041.76.76 0 0 1 1.06.05l4.87 5.264a.4.4 0 0 1 .052.08 1 1 0 0 0 .044.072.4.4 0 0 1 .042.069",
  clipRule: "evenodd"
}));

export { SvgArrowShow24 as default };
//# sourceMappingURL=ArrowShow24.js.map
